<template>
  <div class="content">
    <div class="activityList">
      <div class="pro_col_tt">服务活动</div>
      <div class="list_area">
        <div class="item" v-for="item in activities" :key="item.id">
          <div class="pic">
            <img v-if="item.imgUrl" :src="item.imgUrl">
          </div>
          <div class="con">
            <div class="info"  @click="goDetail(item)">
              <div class="title">{{ item.title }}</div>
              <p class="intro"><span>活动简介：</span>{{ item.activityIntro }}</p>
              <p><span>活动日期：{{ item._applyStartDate }} 至 {{ item._applyEndDate }}</span></p>
              <div class="btn1" :class="{'hasEnd': hasEnd(item._applyEndDate)}">{{ hasEnd(item._applyEndDate)? '报名截止': '我要报名' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pagebar" style="display: flex;align-items: center;justify-content: center;padding: 20px 0">
      <!-- <a-pagination show-quick-jumper :default-current="1" :current="pageNumber" :pageSize="limit" :total="total"
                    @change="onChange"/> -->
      <a-pagination :default-current="1" :current="pageNumber" :pageSize="limit" :total="total" @change="onChange"/>
    </div>
  </div>
</template>

<script>
import {getActivities} from "@/api/home";
import {timeFormatter} from "@/utils/common";

export default {
  name: 'activityList',
  data() {
    return {
      pageNumber: 1,
      limit: 8,
      total: 8,
      activities: []
    }
  },
  created() {
    this.getActivities()
  },
  methods: {
    onChange(pageNumber) {
      this.pageNumber = pageNumber
      this.getActivities()
    },
    hasEnd(end){
      let nowTime = this.$moment().unix()
      let endTime = this.$moment(end).unix()
      let hasEnd = nowTime > endTime ? true : false
      return hasEnd
    },
    goDetail(item) {
      this.$router.push({
        path: '/activity/info',
        query: {id: item.id}
      });
    },
    async getActivities() {
      try {
        const res = await getActivities({page: this.pageNumber, limit: this.limit})

        // console.log(res)
        this.total = res.data.total

        this.activities = res?.data?.list.map(item => {
          item.imgUrl = item.imgUrl || require('@/assets/images/r2.jpg')
          item._applyStartDate = item.applyStartDate.split(" ")[0]
          item._applyEndDate = item.applyEndDate.split(" ")[0]
          item._day = item._applyStartDate.split("-")[2]
          return item
        }) || []
        // this.currentActivity = this.activities[0] || null
        // this.activityDateList = this.activities.map(item => {
        //   return {date: timeFormatter(item.applyStartDate), info: item.activityIntro, id: item.id}
        // })
      } catch (e) {
        console.error(e)
      }
    },
  }
}
</script>

<style scoped>
.activityList {
  width: 1200px;
  margin: 0 auto;
}

.pro_col_tt {
  font-size: 24px;
  color: #0075ed;
  font-weight: bold;
  padding-top: 20px;
  padding-bottom: 7px;
  border-bottom: 1px solid #0075ed;
}

.list_area {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 20px;
}

.item {
  margin-right: 26px;
  margin-bottom: 20px;
}

.item:nth-child(4n) {
  margin-right: 0;
}

.item .pic img {
  width: 280px;
  height: 200px;
}

.item .con {
  cursor: pointer;
  width: 280px;
  border: 1px solid #eeeeee;
}

.item .con .info {
  padding: 15px;
}

.item .con .info .title {
  font-size: 18px;
  color: #5997de;
  line-height: 25px;
  min-height: 60px;
  padding-bottom: 10px;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.item .con .info p {
  font-size: 14px;
  color: #999;
  line-height: 25px;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.item .con .info .intro{
  min-height: 50px;
}

.item .con .info p span {
  color: #ff841c;
}

.item .con .info .btn1 {
  margin-top: 13px;
  width: 120px;
  height: 30px;
  text-align: center;
  color: #fff;
  background-color: #ff841c;
  line-height: 30px;
  border-radius: 30px;
}

.item .con .info .btn1.hasEnd{
  background: #b4b4b4;
}

</style>
